import React from 'react';
import { MdClose } from 'react-icons/md';
import { ELCID } from '../models/IMediaToolkit';

export interface IModalProps {
    visible: boolean;
    lcid: ELCID;
    onClose: () => void;
    renderFooter?: () => JSX.Element;
}

export const Modal: React.FunctionComponent<IModalProps> = (props) => {
    if (!props.visible) {
        return null;
    }
    return (
        <div className="fixed bg-opacity-30 bg-aap-gray-500 top-0 left-0 right-0 bottom-0 z-50">
            <div className="bg-white rounded-md shadow-xl shadow-aap-gray-500 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-xl border-8 border-aap-orange-500">
                <button type="button" className="w-10 h-10 absolute top-0 right-0 text-aap-gray-400 hover:text-aap-gray-600" onClick={() => props.onClose()} id={`btn_closeModal_${ELCID[props.lcid]}`}><MdClose size={24} /></button>
                {props.children}
                {props.renderFooter ? (
                    <>
                        <hr />
                        {props.renderFooter()}
                    </>
                ) : null}
            </div>
        </div>
    );
};
